import React from 'react';
import useMediaQuery from "@mui/system/useMediaQuery";
import {Typography, useTheme} from "@mui/joy";
import Dialog from "@mui/material/Dialog";
import {BasicModalContent} from "@dreebit-registry/vsm-microservice-components";
import {resolveErrorMessage} from "../../utils/resolveErrorMessage";
import {useTranslation} from "react-i18next";
import {useMutation, useQuery} from "@apollo/client";
import {toast} from "react-toastify";
import _ from "lodash";
import InstalledBaseTDAForm from "../InstalledBaseTDAForm";
import {ToastMessageListTDAs} from "../../graphql/queries/toastMessageListTDAs";
import {CreateToastMessage} from "../../graphql/mutations/createToastMessage";
import {sanitizeToastMessageInput} from "./sanitizeToastMessageInput";

interface Props {
    open: boolean,
    onClose?: () => void,
}

const CreateSystemAnnouncementModal = ({onClose, open}: Props) => {
    const theme = useTheme();
    const isFullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const {t} = useTranslation();

    const [createToastMessageMutation] = useMutation(CreateToastMessage);

    const {data} = useQuery(ToastMessageListTDAs, {
        variables: {
            typeDefinitionIndex: "TOAST_MESSAGE_CREATE"
        },
        fetchPolicy: "network-only",
    })

    const handleSubmit = (input: any) => {
        return createToastMessageMutation({
                variables: {
                    input: sanitizeToastMessageInput(input)
                },
                refetchQueries: ["ToastMessageList", "ActiveToastMessages"]
            }
        ).then((res) => {
            if (res.data?.createToastMessage?.id) {
                toast.success(t("Successfully created system announcement"));
            } else {
                toast.error(t("Error creating system announcement."))
            }
            if (onClose) {
                onClose();
            }
        }).catch((err) => {
            toast.error(resolveErrorMessage(err, t))
        })
    }

    const attributes = _.get(data, 'toastMessageList.typeDefinitionAttributeList.typeDefinitionAttributes', [])

    return <Dialog open={open} onClose={onClose} fullScreen={isFullScreen}>
        <BasicModalContent onClose={onClose} title={<Typography level={'titleSmallLight'}>{t('Create a new system announcement')}</Typography>}>
            <Typography level={'body-sm'} sx={{color: '#666', pb: '8px'}}>
                {t('Announcements are shown to all users at the top of the app while their status is active and the current date is within the defined date range.')}
            </Typography>
            <InstalledBaseTDAForm
                formStyle={{paddingTop: '0px'}}
                onSubmit={handleSubmit}
                onCancel={onClose}
                submitButtonText={t('Create')}
                attributes={attributes}
            />
        </BasicModalContent>
    </Dialog>
};

export default CreateSystemAnnouncementModal;
